import React from 'react'

//custom components
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy'
import Header from '../../components/auth/Header'
import Footer from '../../components/layouts/Footer'

const PrivacyPolicyPage = () => {
    return (
        <>
            <Header />
            <PrivacyPolicy />
            <Footer />
        </>
    )
};

export default PrivacyPolicyPage 